<style lang="scss" scoped>
.horse-lamp {
  position: relative;

  overflow: hidden;

  font-size: 0;

  .lamp {
    transition-property: transform;

    position: absolute;

    width: 100%;
  }
}
</style>

<template>
  <div class="horse-lamp">
    <div
      class="lamp"
      :style="{
        transform: 'translateY(' + step1 * itemHeight + 'rem)',
        transitionDuration: `${dura1}ms`
      }"
    >
      <slot name="lamps" :arr="arr"></slot>
    </div>
    <div
      class="lamp"
      :style="{
        transform: 'translateY(' + step2 * itemHeight + 'rem)',
        transitionDuration: `${dura2}ms`
      }"
    >
      <slot name="lamps" :arr="arr"></slot>
    </div>
  </div>
</template>

<script>
import { waitTime } from '@/utils/utils'
export default {
  components: {},
  props: {
    arr: {
      type: Array,
      default() {
        return []
      }
    },
    arrLength: {
      // 轮播数组长度
      type: Number,
      default: 0
    },
    aniTime: {
      // 动画播放时间
      type: Number,
      default: 500
    },
    delayTime: {
      // 等待时间
      type: Number,
      default: 1000
    },
    itemHeight: {
      // 数组中每个元素的高度rem
      type: Number,
      default: 0.7
    },
    minScrollNum: {
      type: Number, // 首页新增消息只有一个数据，不要轮播
      default: 1
    }
  },
  data() {
    return {
      ranks: [],
      step1: 0,
      step2: this.arrLength - 1,
      dura1: this.aniTime,
      dura2: this.aniTime
    }
  },
  computed: {
    isPlayAnimation() {
      return this.arrLength > this.minScrollNum
    }
  },
  watch: {
    arrLength(n) {
      this.stopLamp()
      this.restoration().then(() => {
        this.startLamp()
      })
    }
  },
  mounted() {
    if (this.isPlayAnimation) {
      this.active = true
      this.startLamp()
      document.addEventListener('visibilitychange', this.toggleScreen)
    } else if (this.step1 === this.step2) {
      this.step2 = this.step1++
    }
  },
  // 单页离开时停止，回来时继续
  activated() {
    this.active = true
    this.startLamp()
  },
  deactivated() {
    this.active = false
    this.stopLamp()
  },
  destroyed() {
    this.active = false
    document.removeEventListener('visibilitychange', this.toggleScreen)
    this.stopLamp()
  },
  methods: {
    startLamp() {
      const vm = this
      clearInterval(this.timer)

      if (!this.isPlayAnimation) {
        return
      }
      this.timer = setInterval(function () {
        vm.step1--
        vm.step2--
        if (vm.step2 === -1) {
          vm.dura1 = 0
          vm.step1 = vm.arrLength - 1
          setTimeout(function () {
            vm.dura1 = vm.aniTime
          }, 100)
        }
        if (vm.step1 === -1) {
          vm.dura2 = 0
          vm.step2 = vm.arrLength - 1
          setTimeout(function () {
            vm.dura2 = vm.aniTime
          }, 100)
        }
      }, this.aniTime + this.delayTime)
    },
    stopLamp() {
      clearInterval(this.timer)
    },
    // 息屏后android的js继续执行，停止防止render进程不能同步
    toggleScreen() {
      // 当前组件在后台页面不考虑
      if (this.active) {
        document.hidden ? this.stopLamp() : this.startLamp()
      }
    },
    // 动态修改数组，复位功能，当前位置重进滚动
    restoration() {
      const vm = this
      vm.dura1 = 0
      vm.dura2 = 0
      // eslint-disable-next-line no-unused-vars
      if (vm.step1 <= 0) {
        vm.step1 = 0
        vm.step2 = this.arrLength - 1
      } else {
        vm.step1 = this.arrLength - 1
        vm.step2 = 0
      }

      return waitTime(100).then(() => {
        vm.dura1 = vm.aniTime
        vm.dura2 = vm.aniTime
      })
    }
  }
}
</script>
